import { Route, Routes } from 'react-router-dom';
import React, { Suspense } from "react";
import AgregarNovedades from "../../../views/I+D/AgregarNovedades/AgregarNovedades";
import ControlEquipamiento from '../../../views/I+D/ControlEquipamiento/ControlEquipamiento';
import PermisosSumaEquipos from '../../../views/I+D/PermisosSumaEquipos/PermisosSumaEquipos';

const InnovacionDesarrollo = () => {
    return (
        <Routes>
            <Route exact path="/innovacionDesarrollo/novedades"
                   element={
                       <Suspense fallback={<>skeleton</>}>
                           <AgregarNovedades/>
                       </Suspense>
                   }>
            </Route>
            <Route exact path="/innovacionDesarrollo/control-equipamiento"
                   element={
                       <Suspense fallback={<>skeleton</>}>
                           <ControlEquipamiento/>
                       </Suspense>
                   }>
            </Route>
            <Route exact path="/innovacionDesarrollo/permisos-suma-equipos"
                   element={
                       <Suspense fallback={<>skeleton</>}>
                           <PermisosSumaEquipos/>
                       </Suspense>
                   }>
            </Route>
        </Routes>
    )

}

export default InnovacionDesarrollo
